import React from 'react'
import { J1DownleftarrowC, J1ToprightarrowC } from '@e3dc-react/icons'
import { makeStyles } from 'tss-react/mui'
import { Box, Typography } from '@mui/material'
import { isNil } from 'lodash'

const useStyles = makeStyles()(theme => ({
  values: {
    display: 'flex',
    columnGap: theme.spacing(1),
    rowGap: theme.spacing(0),
    flexWrap: 'wrap',
    '& .MuiSvgIcon-root': {
      width: 14,
      height: 18,
      marginLeft: theme.spacing(0.5),
    },
  },
  chargedValue: {
    display: 'inline-flex',
    alignItems: 'end',
    color: theme.palette.text.primary,
    '& svg': {
      marginBottom: theme.spacing(0.5),
    },
  },
  dischargedValue: {
    display: 'inline-flex',
    alignItems: 'end',
    color: theme.palette.text.primary,
    '& svg': {
      marginBottom: theme.spacing(0.5),
    },
  },
}))

interface WallboxChargeDischargeValuesProps {
  energyAll?: number
  energyDischarged?: number
  formatter: (value: number) => { value: string; unit: string }
}

/**
 * Shows discharged and charged energy side by side, used for discharge-capable wallboxes
 */
const WallboxChargeDischargeValues: React.FC<WallboxChargeDischargeValuesProps> = ({ energyAll, energyDischarged, formatter }) => {
  const { classes } = useStyles()
  const formattedDischarged = !isNil(energyDischarged) ? formatter(energyDischarged) : undefined
  const formattedCharged = !isNil(energyAll) ? formatter(energyAll) : undefined

  return (
    <Box className={classes.values}>
      {formattedDischarged && (
        <Box className={classes.dischargedValue}>
          <Typography variant="h1" component="span">
            {formattedDischarged.value}
            <Typography variant="h2" component="span">
              {` ${formattedDischarged.unit}`}
            </Typography>
          </Typography>
          <J1ToprightarrowC color="inherit" fontSize="small" />
        </Box>
      )}
      {formattedCharged && (
        <Box className={classes.chargedValue}>
          <Typography variant="h1" component="span">
            {formattedCharged.value}
            <Typography variant="h2" component="span">
              {` ${formattedCharged.unit}`}
            </Typography>
          </Typography>
          <J1DownleftarrowC color="inherit" fontSize="small" />
        </Box>
      )}
    </Box>
  )
}

export default WallboxChargeDischargeValues
